import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CreateDiamondPackages,
  CreateHostLevel,
  CreateSenderLevel,
  uploadFile,
} from "../../DAL/create";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { enqueueSnackbar } from "notistack";
export const AddPackages = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    amount: "",
    diamonds: "",
    image: "",
    tag: "",
    original: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [type, setType] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = async (e) => {
    const value = e.target.files[0];
    const formData = new FormData();
    formData.append("image", value);
    const resp = await uploadFile(formData);
    setPreviewImage(URL.createObjectURL(value));
    setInputs((prev) => ({ ...prev, image: resp?.data?.url }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputs?.amount) {
      setType(true);
      return;
    }
    if (!inputs?.diamonds) {
      setType(true);
      return;
    }
    if (!inputs?.original) {
      setType(true);
      return;
    }

    if (inputs?.diamonds < 1) {
      enqueueSnackbar('Diamonds cannot be less than 1');
      return
    }
    if (inputs?.amount >= inputs?.original) {
      enqueueSnackbar("Discounted amount must be less than the original amount", {
        variant: "error",
      });
      return;
    }
    const data = {
      amount: Number(inputs?.amount),
      tag: inputs?.tag,
      original: Number(inputs?.original),
      diamond: Number(inputs?.diamonds),
      pictureUrl: inputs?.image,
    };
    const resp = await CreateDiamondPackages(data);
    if (resp?.status == 201) {
      enqueueSnackbar("Diamond package created successfully", {
        variant: "success",
      });
      navigate("/diamonds-packages");
    } else {
      enqueueSnackbar("Error while created Diamond package", {
        variant: "error",
      });
    }
  };

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/diamonds-packages")}
          />
          <Typography variant="h6">Add Diamonds Packages</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "6px" }}>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Diamonds *"
              type="number"
              value={inputs?.diamonds}
              name="diamonds"
              onChange={(e) =>
                setInputs((prev) => ({
                  ...prev,
                  ["diamonds"]: e.target.value < 0 ? 0 : e.target.value,
                }))
              }
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true &&
                inputs?.diamonds == "" &&
                "Diamond field is required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Original Amount *"
              type="number"
              value={inputs?.original}
              name="original"
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true &&
                inputs?.original == "" &&
                "Original amount field is required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={6}>
            <TextField
              fullWidth
              size="small"
              label="Enter Discounted Amount *"
              type="number"
              value={inputs?.amount}
              name="amount"
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />
            <FormHelperText sx={{ color: "red" }}>
              {type == true &&
                inputs?.amount == "" &&
                "Discounted amount field is Required"}
            </FormHelperText>
          </Grid>
          <Grid item lg={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              className="gradientButton"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
